// src/pages/admin/components/PropertyImagesPicker.jsx
import React from 'react';
import styled from 'styled-components';
import { AdminAPI } from '../../../api/admin';
import { normalizeMediaUrl } from '../../../api/base';

const Wrap = styled.div`display:grid; gap:12px;`;

/* Панель загрузки */
const FilePreview = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  
  .file-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    background: white;
    border-radius: 6px;
    font-size: 12px;
    color: #495057;
    border: 1px solid #dee2e6;
  }
  
  .file-icon {
    width: 16px;
    height: 16px;
    background: #007bff;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 10px;
    font-weight: bold;
  }
`;

const Uploader = styled.div`
  display:flex; gap:10px; align-items:center; flex-wrap:wrap;
  input[type="file"]{ display:none; }
  .btn{
    padding:10px 14px; border:1px solid var(--bdr); border-radius:12px;
    background:var(--card); cursor:pointer; font-weight:700;
    transition: all 0.2s ease;
    position: relative;
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      background: #f5f5f5;
    }
    
    &.preparing {
      background: #fff3cd;
      border-color: #ffc107;
      color: #856404;
      animation: pulse 1.5s ease-in-out infinite;
    }
    
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.7; }
    }
    
    &.uploading {
      background: #e3f2fd;
      border-color: #2196f3;
      color: #1976d2;
    }
    
    &.success {
      background: #e8f5e8;
      border-color: #4caf50;
      color: #2e7d32;
    }
    
    &.error {
      background: #ffebee;
      border-color: #f44336;
      color: #c62828;
    }
  }
  small{ opacity:.8; }
`;

const UploadProgress = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  
  .progress-bar {
    width: 120px;
    height: 6px;
    background: #e0e0e0;
    border-radius: 3px;
    overflow: hidden;
  }
  
  .progress-fill {
    height: 100%;
    background: #2196f3;
    transition: width 0.3s ease;
    border-radius: 3px;
  }
`;

const StatusMessage = styled.div`
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  &.success {
    background: #e8f5e8;
    color: #2e7d32;
  }
  
  &.error {
    background: #ffebee;
    color: #c62828;
  }
  
  &.uploading {
    background: #e3f2fd;
    color: #1976d2;
  }
`;

/* Обёртка и сетка превью — со своей прокруткой */
const GridWrap = styled.div`
  max-height: 68vh;  /* прокрутка при большом количестве фото */
  overflow: auto;
  padding-right: 4px;
`;
const Grid = styled.div`
  display:grid;
  grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); /* крупнее превью */
  gap:12px;
`;

/* Ячейка превью + панель действий */
const Cell = styled.div`
  border:1px solid var(--bdr); border-radius:14px; overflow:hidden; background:var(--card);
  display:flex; flex-direction:column;

  .thumb{
    width:100%; aspect-ratio: 3/2; object-fit:cover; display:block;
    cursor: zoom-in; /* показываем, что по фото можно кликнуть */
  }

  footer{
    display:grid; gap:8px; padding:10px;
  }
  .row{
    display:flex; align-items:center; justify-content:space-between; gap:8px; flex-wrap:wrap;
  }
  .btn{
    padding:8px 10px; border:1px solid var(--bdr); border-radius:10px;
    background:var(--bg); cursor:pointer; font-weight:600; font-size:14px;
  }
  [data-main="true"]{
    background: var(--primary); color: var(--primaryFg); border-color: transparent;
  }
`;

/* Лайтбокс для просмотра фото */
const Lightbox = styled.div`
  position: fixed; inset:0; z-index: 1000;
  background: rgba(0,0,0,.8);
  display:flex; align-items:center; justify-content:center;
  padding: 24px;

  .imgWrap{
    max-width: min(96vw, 1400px);
    max-height: 90vh;
  }
  img{
    display:block; max-width:100%; max-height: 90vh; border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0,0,0,.55);
  }

  .close, .prev, .next{
    position: absolute; top: 50%; transform: translateY(-50%);
    padding:12px 14px; border-radius:12px; border:none; cursor:pointer; font-weight:800;
    background: rgba(255,255,255,.12); color:#fff; backdrop-filter: blur(6px);
  }
  .close{
    top: 24px; right: 24px; transform:none; font-size:16px;
  }
  .prev{ left: 18px; }
  .next{ right: 18px; }
  .counter{
    position:absolute; bottom: 18px; left: 50%; transform: translateX(-50%);
    color:#fff; opacity:.9; font-weight:700; background: rgba(0,0,0,.35);
    padding:6px 10px; border-radius: 10px;
  }
`;

function normalizeFile(resp){
  // поддержка обоих форматов: {file:{...}} и плоский {...}
  const f = resp?.file || resp;
  return {
    id: f?.id,
    url: f?.url,
    thumbnail_url: f?.thumbnail_url || f?.url,
    is_main: false,
  };
}

/**
 * value: [{ id, url, thumbnail_url, is_main }]
 * onChange(next)
 * autoDeleteUploads: если true — при удалении из списка удаляем файл и на сервере (для «черновых» загрузок)
 */
export default function PropertyImagesPicker({ value = [], onChange, autoDeleteUploads = true }) {
  const [busy, setBusy] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState({ current: 0, total: 0 });
  const [uploadStatus, setUploadStatus] = React.useState(''); // 'uploading', 'success', 'error'
  const [filesSelected, setFilesSelected] = React.useState(false); // мгновенная индикация выбора файлов
  const [selectedFileNames, setSelectedFileNames] = React.useState([]); // имена выбранных файлов
  const fileInputRef = React.useRef(null);

  // лайтбокс
  const [lbIndex, setLbIndex] = React.useState(null); // number | null
  const hasLightbox = lbIndex !== null;

  const addFiles = async (files) => {
    if (!files?.length) return;
    
    // Мгновенная индикация выбора файлов
    setFilesSelected(true);
    setSelectedFileNames(Array.from(files).map(f => f.name));
    
    // Небольшая задержка для визуальной обратной связи
    await new Promise(resolve => setTimeout(resolve, 200));
    
    setBusy(true);
    setUploadProgress({ current: 0, total: files.length });
    setUploadStatus('uploading');
    
    try{
      const results = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        setUploadProgress({ current: i + 1, total: files.length });
        
        try {
          const resp = await AdminAPI.uploadMedia(file);
          const nf = normalizeFile(resp);
          if (nf?.id && nf?.url) {
            results.push(nf);
          }
        } catch (error) {
          console.error(`Failed to upload file ${file.name}:`, error);
          // Продолжаем загрузку остальных файлов
        }
      }
      
      if (results.length > 0) {
        const next = [...value, ...results];
        // если до этого не было главной — пометим первую загруженную
        if (!next.some(x=>x.is_main) && next.length) next[0].is_main = true;
        onChange?.(next);
        setUploadStatus('success');
        
        // Показываем успех на 2 секунды
        setTimeout(() => {
          setUploadStatus('');
        }, 2000);
      } else {
        setUploadStatus('error');
        setTimeout(() => {
          setUploadStatus('');
        }, 3000);
      }
    } catch (error) {
      console.error('Upload failed:', error);
      setUploadStatus('error');
      setTimeout(() => {
        setUploadStatus('');
      }, 3000);
    } finally {
      setBusy(false);
      setFilesSelected(false);
      setSelectedFileNames([]);
      setUploadProgress({ current: 0, total: 0 });
      // Очищаем input для возможности повторной загрузки тех же файлов
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const removeAt = async (idx) => {
    const img = value[idx];
    if (!img) return;

    // Сначала убираем из UI
    const next = value.slice();
    const [removed] = next.splice(idx, 1);
    if (removed?.is_main && next[0]) next[0].is_main = true;
    onChange?.(next);

    // корректируем индекс лайтбокса
    if (lbIndex !== null) {
      if (idx === lbIndex) setLbIndex(null);
      else if (idx < lbIndex) setLbIndex(i => (i != null ? i - 1 : null));
    }

    // Затем удаляем на сервере, если это «черновая» загрузка (ещё ни к чему не привязанная)
    if (autoDeleteUploads && removed?.id) {
      try { await AdminAPI.deleteMedia(removed.id); }
      catch (e) { console.warn('Failed to delete media on server', e); }
    }
  };

  const move = (idx, dir) => {
    const j = idx + dir;
    if (j < 0 || j >= value.length) return;
    const next = value.slice();
    const [x] = next.splice(idx, 1);
    next.splice(j, 0, x);
    onChange?.(next);
    // двигаем и в лайтбоксе, если открыт
    if (lbIndex === idx) setLbIndex(j);
  };

  const setMain = (idx) => {
    const next = value.map((x, i) => ({ ...x, is_main: i === idx }));
    onChange?.(next);
  };

  // управление с клавиатуры в лайтбоксе
  React.useEffect(() => {
    if (!hasLightbox) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setLbIndex(null);
      if (e.key === 'ArrowRight') setLbIndex(i => (i === null ? null : Math.min(value.length-1, i+1)));
      if (e.key === 'ArrowLeft')  setLbIndex(i => (i === null ? null : Math.max(0, i-1)));
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [hasLightbox, value.length]);

  return (
    <Wrap>
      <Uploader>
        <input
          ref={fileInputRef}
          id="prop-imgs-input"
          type="file"
          accept="image/*"
          multiple
          onChange={(e)=>addFiles(Array.from(e.target.files||[]))}
        />
        <button 
          type="button" 
          className={`btn ${filesSelected && !busy ? 'preparing' : uploadStatus}`} 
          onClick={()=>fileInputRef.current?.click()} 
          disabled={busy || filesSelected}
        >
          {filesSelected && !busy ? (
            selectedFileNames.length === 1 ? 
              'Подготовка файла...' : 
              `Подготовка ${selectedFileNames.length} файлов...`
          ) : busy ? (
            uploadProgress.total > 1 ? 
              `Загрузка ${uploadProgress.current}/${uploadProgress.total}...` : 
              'Загрузка...'
          ) : (
            uploadStatus === 'success' ? '✓ Загружено!' :
            uploadStatus === 'error' ? '✗ Ошибка загрузки' :
            'Добавить фото'
          )}
        </button>
        
        {filesSelected && !busy && selectedFileNames.length > 0 && (
          <FilePreview>
            {selectedFileNames.map((name, idx) => (
              <div key={idx} className="file-item">
                <div className="file-icon">📷</div>
                <span>{name.length > 20 ? name.substring(0, 17) + '...' : name}</span>
              </div>
            ))}
          </FilePreview>
        )}
        
        {busy && uploadProgress.total > 1 && (
          <UploadProgress>
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${(uploadProgress.current / uploadProgress.total) * 100}%` }}
              />
            </div>
            <span>{Math.round((uploadProgress.current / uploadProgress.total) * 100)}%</span>
          </UploadProgress>
        )}
        
        {uploadStatus && !busy && (
          <StatusMessage className={uploadStatus}>
            {uploadStatus === 'success' && '✓ Изображения успешно загружены'}
            {uploadStatus === 'error' && '✗ Не удалось загрузить некоторые файлы'}
          </StatusMessage>
        )}
        
        <small>
          {filesSelected && !busy ? 
            'Файлы выбраны, начинаем загрузку...' :
            busy ? 
              'Пожалуйста, дождитесь завершения загрузки...' : 
              'Можно выбрать несколько файлов. После сохранения они привяжутся к объекту.'
          }
        </small>
      </Uploader>

      {!value.length ? (
        <div style={{color:'#777'}}>Пока нет фото. Добавьте изображения выше.</div>
      ) : (
        <GridWrap>
          <Grid>
            {value.map((img, idx)=>(
              <Cell key={(img.id ?? img.url) + '_' + idx}>
                <img
                  className="thumb"
                  src={normalizeMediaUrl(img.thumbnail_url || img.url)}
                  alt={`photo-${idx}`}
                  onClick={()=>setLbIndex(idx)}
                />
                <footer>
                  <div className="row">
                    <button
                      type="button"
                      className="btn"
                      data-main={img.is_main}
                      onClick={()=>setMain(idx)}
                      title="Сделать главной"
                    >
                      {img.is_main ? 'Главная' : 'Сделать главной'}
                    </button>
                    <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                      <button type="button" className="btn" onClick={()=>move(idx,-1)} title="Вверх">↑ Вверх</button>
                      <button type="button" className="btn" onClick={()=>move(idx, 1)} title="Вниз">↓ Вниз</button>
                      <button type="button" className="btn" onClick={()=>removeAt(idx)} title="Удалить">✕ Удалить</button>
                    </div>
                  </div>
                </footer>
              </Cell>
            ))}
          </Grid>
        </GridWrap>
      )}

      {/* Лайтбокс */}
      {hasLightbox && (
        <Lightbox onClick={(e)=>{ if (e.target === e.currentTarget) setLbIndex(null); }}>
          <button className="close" onClick={()=>setLbIndex(null)} aria-label="Закрыть">✕</button>
          {lbIndex > 0 && (
            <button className="prev" onClick={(e)=>{ e.stopPropagation(); setLbIndex(i=> (i>0 ? i-1 : i)); }} aria-label="Предыдущее">‹</button>
          )}
          {lbIndex < value.length-1 && (
            <button className="next" onClick={(e)=>{ e.stopPropagation(); setLbIndex(i=> (i<value.length-1 ? i+1 : i)); }} aria-label="Следующее">›</button>
          )}

          <div className="imgWrap" onClick={(e)=>e.stopPropagation()}>
            <img src={normalizeMediaUrl(value[lbIndex].url || value[lbIndex].thumbnail_url)} alt={`large-${lbIndex}`} />
          </div>

          <div className="counter">{lbIndex+1} / {value.length}</div>
        </Lightbox>
      )}
    </Wrap>
  );
}
